<template>
      <div class="title">
        <div class="name text">
          {{camera.camera_info[0].name}}
        </div> 
        <div class="geoaddr text">
          Розмiщення: {{camera.camera_info[0].geoaddr}}
        </div> 
      </div>
      <video ref='Player' id="video-js"  class="video-js vjs-big-play-centered" controls></video>

</template>

<script>

import videojs from 'video.js';

export default {


  name: "StreamToAllCamerasListCompoent",

   props: ['camera'],

  data () {
    return {

    }
  },

  mounted() {
    this.player = videojs(this.$refs.Player, 
    {
      controls: true,
      fluid: true,
      fill: true,
      responsive: true,
      errorDisplay: false,
      aspectRatio: '16:10',
      poster: this.camera.imgurl,
      sources: [
        {
          src: this.camera.hlsurl,
          type: "application/x-mpegURL"
        }
      ]
    })
    
  },

  methods: {

}
}


</script>

<style scoped>
  .title {
    text-align: center;
  }

  .name {
    font-weight: bold;
  }

  .geoaddr {
    font-size: 14px;
  }

  video {
      max-height: 650px;
  }

</style>